var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasFeature("FEATURE_ALLERGEN_LIST") || _vm.preview
    ? _c("div", { staticClass: "container" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.productsLoading && !_vm.loading,
                expression: "!productsLoading && !loading"
              }
            ],
            staticClass: "allergen-list",
            class: {
              "allergen-list--scrollable": _vm.scrollLeft < _vm.scrollMax
            },
            style:
              "--allergens-length: " +
              _vm.allergens.length +
              "; --allergens-scroll: -" +
              _vm.scrollLeft +
              "px; --allergens-header-height: " +
              _vm.headerHeight +
              "px;",
            on: {
              wheel: _vm.onMouseWheel,
              touchstart: _vm.onTouchStart,
              touchmove: _vm.onTouchMove
            }
          },
          [
            _c(
              "div",
              { ref: "allergenList", staticClass: "allergen-list__wrapper" },
              [
                _c(
                  "header",
                  {
                    ref: "allergenListHeader",
                    staticClass: "allergen-list__header"
                  },
                  [
                    _c(
                      "div",
                      {
                        ref: "allergenListFiller",
                        staticClass:
                          "allergen-list__col allergen-list__col--filler"
                      },
                      [
                        _c("h1", {
                          staticClass: "allergen-list__title",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("shoplist.product.details.allergens.title")
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("h2", {
                          staticClass: "allergen-list__subtitle",
                          domProps: { innerHTML: _vm._s(_vm.locationName) }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.allergens, function(allergen) {
                      return _c(
                        "div",
                        {
                          key: allergen,
                          staticClass:
                            "allergen-list__col allergen-list__col--header allergen-list__col--data",
                          class: {
                            "allergen-list__col--active": _vm.activeAllergens.includes(
                              allergen
                            )
                          }
                        },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "shoplist.product.details.allergens." +
                                    allergen
                                )
                              )
                            }
                          })
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "section",
                  { staticClass: "allergen-list__body" },
                  [
                    _vm._l(_vm.categoriesEnhancedSpread, function(category) {
                      return [
                        _c(
                          "div",
                          {
                            key: category.category.code,
                            staticClass: "allergen-list__category"
                          },
                          [
                            category.category.name
                              ? _c("h3", {
                                  staticClass:
                                    "allergen-list__col allergen-list__col--category",
                                  domProps: {
                                    innerHTML: _vm._s(category.category.name)
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.allergens, function(allergen) {
                              return _c("div", {
                                key: allergen,
                                staticClass:
                                  "allergen-list__col allergen-list__col--data"
                              })
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm._l(category.products, function(product) {
                          return _c(
                            "div",
                            {
                              key: category.category.code + product.code,
                              staticClass: "allergen-list__product",
                              on: {
                                mouseenter: function($event) {
                                  return _vm.onMouseEnter(product)
                                },
                                mouseleave: _vm.onMouseLeave,
                                click: function($event) {
                                  return _vm.onClick(product)
                                }
                              }
                            },
                            [
                              product.displayName
                                ? _c("div", {
                                    staticClass:
                                      "allergen-list__col allergen-list__col--product",
                                    class: {
                                      "allergen-list__col--active":
                                        _vm.activeProduct &&
                                        _vm.activeProduct.code === product.code
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(product.displayName)
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.allergens, function(allergen) {
                                return _c("div", {
                                  key: allergen,
                                  staticClass:
                                    "allergen-list__col allergen-list__col--data",
                                  class: {
                                    "allergen-list__col--active":
                                      _vm.activeProduct &&
                                      _vm.activeProduct.code === product.code,
                                    "allergen-list__col--contained":
                                      product.allergen &&
                                      product.allergen.includes(allergen)
                                  }
                                })
                              })
                            ],
                            2
                          )
                        })
                      ]
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "allergen-list__scroller" })
              ]
            ),
            _vm._v(" "),
            _c(
              "footer",
              { staticClass: "allergen-list__footer" },
              [
                _c("div", {
                  staticClass: "allergen-list__footer-info",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(
                        "shoplist.product.details.allergens.additionalInfo"
                      )
                    )
                  }
                }),
                _vm._v(" "),
                _c("Button", {
                  attrs: {
                    level: "tertiary",
                    text: _vm.$t(
                      "shoplist.product.details.allergens.pdfButton"
                    ),
                    href: _vm.pdfUrl,
                    target: "_blank",
                    arrow: ""
                  }
                })
              ],
              1
            )
          ]
        )
      ])
    : _c("div", { staticClass: "container" }, [
        _c("h1", {
          domProps: {
            innerHTML: _vm._s(
              _vm.$t("shoplist.product.details.allergens.comingSoon")
            )
          }
        })
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }